export default __webpack_public_path__ + "static/media/sole-3.984ffd69.png";